/* ==========================================================================
   Gia's Kids Wear — JS global
   Drawer de carrito, menú móvil, buscador, announcement rotativo y AJAX cart.
   Vanilla JS, sin dependencias.
   ========================================================================== */
(function () {
  'use strict';

  const overlay = document.querySelector('[data-overlay]');

  /* ----- Helpers de apertura/cierre ----- */
  function openOverlay() {
    if (!overlay) return;
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add('is-active'));
    document.body.style.overflow = 'hidden';
  }
  function closeOverlay() {
    if (!overlay) return;
    overlay.classList.remove('is-active');
    setTimeout(() => { overlay.hidden = true; }, 200);
    document.body.style.overflow = '';
  }

  /* ----- Cart drawer ----- */
  const drawer = document.querySelector('[data-cart-drawer]');
  // Panel lateral de recomendaciones (carrito vacío): abre/cierra con el drawer
  function toggleCartRecos(open) {
    // Hay dos: el panel lateral (escritorio) y el bloque en línea (móvil)
    document.querySelectorAll('[data-cart-recos]').forEach((el) => {
      el.classList.toggle('is-open', open);
    });
  }
  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    // Pequeño retraso para que el panel entre justo detrás del carrito
    window.setTimeout(() => toggleCartRecos(true), 140);
    openOverlay();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    toggleCartRecos(false);
    closeOverlay();
  }

  document.querySelectorAll('[data-cart-toggle]').forEach((b) => b.addEventListener('click', openCart));
  document.querySelectorAll('[data-cart-close]').forEach((b) => b.addEventListener('click', closeCart));

  /* ----- Menú móvil ----- */
  const nav = document.querySelector('[data-nav]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  // Punto único de abrir/cerrar: antes el overlay y el ESC limpiaban el header
  // pero NO el wrapper de la sección, que se quedaba con .nav-open pegado.
  function setNav(open) {
    if (!nav) return;
    nav.classList.toggle('is-open', open);
    if (menuToggle) menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    // Fallback de :has() — el WRAPPER de la sección (que crea el stacking
    // context por el sticky) debe superar al overlay con el menú abierto.
    const hdr = document.querySelector('[data-header]');
    const wrap = hdr && hdr.closest('.shopify-section');
    if (hdr) hdr.classList.toggle('nav-open', open);
    if (wrap) wrap.classList.toggle('nav-open', open);
    open ? openOverlay() : closeOverlay();
  }
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', () => setNav(!nav.classList.contains('is-open')));
  }
  document.querySelectorAll('[data-menu-close]').forEach((b) => {
    b.addEventListener('click', () => setNav(false));
  });

  /* ----- Texto expandible ("Leer más") -----
     Delegado: sirve para cualquier número de instancias y sobrevive a los
     re-render de secciones del editor de temas. */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-expand-toggle]');
    if (!btn) return;
    const root = btn.closest('[data-expand]');
    if (!root) return;
    const body = root.querySelector('.xtext__body');
    if (!body) return;

    const wasOpen = root.classList.contains('is-open');
    const label = btn.querySelector('.xtext__toggle-label');

    if (!wasOpen) {
      // Altura exacta en px: transicionar hacia 'auto' no anima.
      body.style.maxHeight = body.scrollHeight + 'px';
      root.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      if (label) label.textContent = label.dataset.labelLess || 'Leer menos';

      // Al terminar se suelta el max-height para que el texto pueda recolocarse
      // si cambia el ancho de la ventana estando abierto.
      body.addEventListener('transitionend', function done(ev) {
        if (ev.propertyName !== 'max-height') return;
        body.style.maxHeight = 'none';
        body.removeEventListener('transitionend', done);
      });
    } else {
      // Fijar la altura actual antes de plegar: desde 'none' no hay origen.
      body.style.maxHeight = body.scrollHeight + 'px';
      requestAnimationFrame(function () {
        root.classList.remove('is-open');
        body.style.maxHeight = '';
      });
      btn.setAttribute('aria-expanded', 'false');
      if (label) label.textContent = label.dataset.labelMore || 'Leer más';

      // Si al plegar el inicio del texto queda por encima del viewport, se
      // vuelve a él: si no, el usuario acaba mirando a mitad de página.
      const top = root.getBoundingClientRect().top;
      if (top < 0) {
        window.scrollBy({ top: top - 24, behavior: 'smooth' });
      }
    }
  });

  /* ----- Buscador (caída + predictivo en vivo) ----- */
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchPanel = document.querySelector('[data-search-panel]');
  function closeSearch() {
    if (!searchPanel) return;
    searchPanel.classList.remove('is-open');
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
  }
  if (searchToggle && searchPanel) {
    searchToggle.setAttribute('aria-expanded', 'false');
    searchToggle.addEventListener('click', () => {
      const open = searchPanel.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        const input = searchPanel.querySelector('input');
        if (input) window.setTimeout(() => input.focus(), 60);
      }
    });

    /* Búsqueda predictiva: resultados mientras escribes */
    const sInput = searchPanel.querySelector('[data-predictive-input]');
    const sResults = searchPanel.querySelector('[data-predictive-results]');
    if (sInput && sResults) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      let debounce;

      const esc = (s) => String(s).replace(/[&<>"']/g, (c) => (
        { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
      ));

      const render = (products, q) => {
        if (!products.length) {
          sResults.innerHTML = `<p class="predictive__empty">Sin resultados para “${esc(q)}”.</p>`;
          return;
        }
        const items = products.map((p) => `
          <a class="predictive__item" href="${p.url}">
            ${p.image
              ? `<img class="predictive__img" src="${p.image}" alt="" loading="lazy" width="48" height="48">`
              : `<span class="predictive__img predictive__img--ph"></span>`}
            <span class="predictive__info">
              <span class="predictive__title">${esc(p.title)}</span>
              ${p.price ? `<span class="predictive__price">${esc(p.price)}</span>` : ''}
            </span>
          </a>`).join('');
        sResults.innerHTML = items +
          `<a class="predictive__all" href="${root}search?q=${encodeURIComponent(q)}">Ver todos los resultados →</a>`;
      };

      sInput.addEventListener('input', () => {
        const q = sInput.value.trim();
        window.clearTimeout(debounce);
        if (q.length < 2) { sResults.hidden = true; sResults.innerHTML = ''; return; }
        debounce = window.setTimeout(async () => {
          try {
            const url = `${root}search/suggest.json?q=${encodeURIComponent(q)}`
              + `&resources[type]=product&resources[limit]=6`
              + `&resources[options][unavailable_products]=last`;
            const res = await fetch(url);
            const data = await res.json();
            const products = ((data.resources || {}).results || {}).products || [];
            render(products, q);
            sResults.hidden = false;
          } catch (e) {
            sResults.hidden = true;
          }
        }, 220);
      });
    }
  }

  /* ----- Colección: toggle de columnas (VER 2/3/4) ----- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-view-btn]');
    if (!btn) return;
    const scope = btn.closest('[data-section-id]') || document;
    const grid = scope.querySelector('[data-product-grid]');
    if (!grid) return;
    grid.style.setProperty('--pg-cols', btn.dataset.viewBtn);
    grid.dataset.cols = btn.dataset.viewBtn;
    scope.querySelectorAll('[data-view-btn]').forEach((b) => b.classList.toggle('is-active', b === btn));
  });

  /* ----- Carrusel de recomendaciones del carrito (infinito + auto-desliza + flechas) ----- */
  function initUpsellCarousel(root) {
    if (!root || root.dataset.upsellInit === '1') return;
    const track = root.querySelector('[data-upsell-track]');
    if (!track) return;
    root.dataset.upsellInit = '1';

    const gap = () => parseFloat(getComputedStyle(track).columnGap) || 24;
    const stepSize = () => {
      const card = track.querySelector('.product-card');
      return card ? card.getBoundingClientRect().width + gap() : 280;
    };

    // Loop infinito: clonamos el set original y envolvemos el scroll.
    const canScroll = track.scrollWidth > track.clientWidth + 4;
    let setWidth = 0;
    if (canScroll) {
      setWidth = track.scrollWidth + gap(); // ancho de un set completo (con su gap)
      Array.prototype.slice.call(track.children).forEach((node) => {
        const clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
    }

    let wrapping = false;
    track.addEventListener('scroll', () => {
      if (!setWidth || wrapping) return;
      if (track.scrollLeft >= setWidth) {
        wrapping = true;
        const sb = track.style.scrollBehavior; track.style.scrollBehavior = 'auto';
        track.scrollLeft -= setWidth;
        track.style.scrollBehavior = sb; wrapping = false;
      } else if (track.scrollLeft <= 0) {
        wrapping = true;
        const sb = track.style.scrollBehavior; track.style.scrollBehavior = 'auto';
        track.scrollLeft += setWidth;
        track.style.scrollBehavior = sb; wrapping = false;
      }
    }, { passive: true });

    // Rueda del mouse → desplazamiento horizontal (móvil usa swipe nativo).
    if (canScroll) {
      track.addEventListener('wheel', (e) => {
        const delta = Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
        if (delta === 0) return;
        e.preventDefault();
        const sb = track.style.scrollBehavior; track.style.scrollBehavior = 'auto';
        track.scrollLeft += delta;
        track.style.scrollBehavior = sb;
      }, { passive: false });
    }

    // Flechas (control manual)
    const prevBtn = root.querySelector('[data-upsell-prev]');
    const nextBtn = root.querySelector('[data-upsell-next]');
    if (nextBtn) nextBtn.addEventListener('click', () => track.scrollBy({ left: stepSize(), behavior: 'smooth' }));
    if (prevBtn) prevBtn.addEventListener('click', () => track.scrollBy({ left: -stepSize(), behavior: 'smooth' }));

    // Auto-deslizamiento (se mueve solo); pausa al pasar el cursor.
    let timer = null;
    const start = () => { if (!timer && canScroll) timer = window.setInterval(() => track.scrollBy({ left: stepSize(), behavior: 'smooth' }), 3000); };
    const stop = () => { if (timer) { window.clearInterval(timer); timer = null; } };
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    track.addEventListener('touchstart', stop, { passive: true });
    start();
  }
  document.querySelectorAll('[data-upsell-carousel]').forEach(initUpsellCarousel);
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelectorAll) {
      e.target.querySelectorAll('[data-upsell-carousel]').forEach(initUpsellCarousel);
    }
  });

  /* ----- Recomendaciones del drawer: rueda del mouse → scroll horizontal ----- */
  document.addEventListener('wheel', (e) => {
    const track = e.target.closest && e.target.closest('[data-cu-track]');
    if (!track) return;
    const delta = Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
    if (delta === 0) return;
    e.preventDefault();
    track.scrollLeft += delta;
  }, { passive: false });

  /* ----- Clic fuera cierra el buscador ----- */
  if (searchPanel) {
    document.addEventListener('click', (e) => {
      if (!searchPanel.classList.contains('is-open')) return;
      if (searchPanel.contains(e.target)) return;
      if (searchToggle && searchToggle.contains(e.target)) return;
      closeSearch();
    });
  }

  /* ----- Overlay cierra todo ----- */
  if (overlay) {
    overlay.addEventListener('click', () => {
      closeCart();
      setNav(false);
      closeOverlay();
    });
  }
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeCart();
      setNav(false);
      closeSearch();
      closeOverlay();
    }
  });

  /* ----- Header sticky shadow ----- */
  const header = document.querySelector('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ----- Announcement bar: carrusel deslizante con bucle infinito ----- */
  const ann = document.querySelector('[data-announcement]');
  if (ann) {
    const track = ann.querySelector('[data-announcement-track]');
    const items = track ? Array.from(track.querySelectorAll('[data-announcement-item]')) : [];
    const total = items.length;

    if (track && total > 1 && ann.dataset.autorotate === 'true') {
      const speed = parseInt(ann.dataset.speed, 10) || 5000;
      const SLIDE_MS = 600; // debe coincidir con la transición CSS
      let idx = 0;
      let timer;

      // Clon del primer mensaje al final para un loop sin salto visible
      track.appendChild(items[0].cloneNode(true));

      const goNext = () => {
        idx += 1;
        track.style.transition = `transform ${SLIDE_MS}ms cubic-bezier(.4,0,.2,1)`;
        track.style.transform = `translateX(-${idx * 100}%)`;

        if (idx === total) {
          // Al llegar al clon (= primer mensaje), saltamos al inicio sin animación
          window.setTimeout(() => {
            track.style.transition = 'none';
            track.style.transform = 'translateX(0)';
            idx = 0;
          }, SLIDE_MS + 20);
        }
      };

      const start = () => { timer = window.setInterval(goNext, speed); };
      const stop = () => { window.clearInterval(timer); };

      start();
      // Pausa al pasar el cursor (mejor UX)
      ann.addEventListener('mouseenter', stop);
      ann.addEventListener('mouseleave', start);
    }
  }


  /* ----- AJAX cart ----- */
  async function refreshCartDrawer() {
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}?section_id=cart-drawer-render`);
      // Fallback: recargar contenido del carrito vía /cart.js para contador
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = el.closest('.cart-drawer__title') ? `(${cart.item_count})` : cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    } catch (e) {
      console.warn('No se pudo refrescar el carrito', e);
    }
  }

  // Interceptar formularios de "añadir al carrito"
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action$="/cart/add"], form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form),
      });
      await refreshCartDrawer();
      openCart();
      // Recargar el cuerpo del drawer para reflejar el nuevo item
      window.location.hash = '';
      reloadDrawerBody();
    } catch (err) {
      console.error(err);
    } finally {
      if (btn) btn.classList.remove('is-loading');
    }
  });

  async function reloadDrawerBody() {
    try {
      const res = await fetch(window.location.pathname + window.location.search);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-drawer]');
      if (fresh && drawer) drawer.innerHTML = fresh.innerHTML;
      // re-bind close
      drawer.querySelectorAll('[data-cart-close]').forEach((b) => b.addEventListener('click', closeCart));
    } catch (e) { /* noop */ }
  }

  // Cambios de cantidad y eliminar dentro del drawer
  document.addEventListener('click', async (e) => {
    const up = e.target.closest('[data-qty-up]');
    const down = e.target.closest('[data-qty-down]');
    const remove = e.target.closest('[data-cart-remove]');
    const target = up || down || remove;
    if (!target) return;
    const line = parseInt(target.dataset.line, 10);
    if (!line) return;

    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    const item = cart.items[line - 1];
    if (!item) return;
    let qty = item.quantity;
    if (up) qty += 1;
    if (down) qty -= 1;
    if (remove) qty = 0;

    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line, quantity: qty }),
    });
    await refreshCartDrawer();
    reloadDrawerBody();
  });
})();
